<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Login" />
            <LoginComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import LoginComp from '../Login/LoginComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'LoginPage',
    components: {
        NavBar,
        PageTitle,
        LoginComp,
        FooterComp,
    }
}
</script>